import parseDate from "../Utils/parseDate";
import { useFormatDate } from "../Intl/Context";

// Formats an event date as the following : "lundi 11 janvier 2021"
//
// TODO : Handle international formats ...
//
export const useFormatEventDate = () => {
  const formatDate = useFormatDate();

  return eventDate => {
    const datetime = parseDate(eventDate);

    const weekday = formatDate(datetime, { weekday: "long" }, false);
    const day = formatDate(datetime, { day: "2-digit" }, false);
    const month = formatDate(datetime, { month: "long" }, false);
    const year = formatDate(datetime, { year: "numeric" }, false);

    return `${weekday}  ${day}  ${month}  ${year}`;
  };
};
